import { createSlice } from "@reduxjs/toolkit";

export const queueSlice = createSlice({
    name: "queue",
    initialState: {
        queue: [],
        wholeQueue: [],
        originalQueue: [],
        calledQueue: [],
        currentLead: null,
        leadInfoStatus: {
            status_name: "",
        },
        queueSource: {}
    },
    reducers: {
        setQueue(state, action) {
            const {payload} = action

            state.queue = payload.slice().sort((b, a) => {
                // Handle cases where date_assigned is null or undefined
                const dateA = a.date_assigned || a.date_uploaded;
                const dateB = b.date_assigned || b.date_uploaded;
                return dateA.localeCompare(dateB);
            });
        },
        setQueueSort(state, action) {
            state.queue = action.payload;
        },
        setWholeQueue(state, action) {
            state.wholeQueue = action.payload;
        },
        addQueue(state, action) {
            state.queue.unshift(action.payload);
        },
        addToBackup(state, action) {
            const combinedArray = [...action.payload, ...state.wholeQueue];
            const uniqueArray = combinedArray.reduce((acc, current) => {
                const x = acc.find(item => item.lead_id === current.lead_id);
                if (!x) {
                    return acc.concat([current]);
                } else {
                    return acc;
                }
            }, []);
            state.wholeQueue = uniqueArray;
        },
        setBackup(state, action) {
            state.originalQueue = action.payload;
        },
        addCurrentLead(state, action) {
            state.currentLead = action.payload;
        },
        updateSpecificLead(state, action) { // updates a single field on a single lead
            const { id, field, value } = action.payload;

            // Find the lead by id
            const lead = state.queue.find((lead) => lead.lead_id === id);

            const wholeQueueLead = state.wholeQueue.find((lead) => lead.lead_id === id);
            const originalQueueLead = state.originalQueue.find((lead) => lead.lead_id === id);
            const calledQueueLead = state.calledQueue.find((lead) => lead.lead_id === id);

            if (lead) {
                lead[field] = value;
            }
            if(wholeQueueLead){
                wholeQueueLead[field] = value
            }
            if(originalQueueLead){
                originalQueueLead[field] = value
            }
            if(calledQueueLead){
                calledQueueLead[field] = value
            }

            if(state.currentLead && state.currentLead.lead_id === id){
                state.currentLead[field] = value
            }
        },
        incrementQueue(state, action) {
            if (state.queue.length >= 1) {
                const itemToMove = state.queue.shift(); // Remove the first item from firstArray
                state.calledQueue.push(itemToMove);
                if (state.queue.length === 0) {
                    state.calledQueue = [];
                }
            }
        },
        removeTagFromLead(state, action){
            const { id, tagId, tagName } = action.payload;

            const lead = state.queue.find((lead) => lead.lead_id === id);
            const wholeQueueLead = state.wholeQueue.find((lead) => lead.lead_id === id);
            const originalQueueLead = state.originalQueue.find((lead) => lead.lead_id === id);
            const calledQueueLead = state.calledQueue.find((lead) => lead.lead_id === id);

            if (lead) {
                const updatedLeadTags = lead.tag_ids
                                            .split(',')
                                            .filter(t => t !== `${tagId}*${tagName}`)
                                            .join(',')

                lead.tag_ids = updatedLeadTags.length > 0 ? updatedLeadTags : null

            }

            if(wholeQueueLead){
                const updatedLeadTags = wholeQueueLead.tag_ids
                                                        .split(',')
                                                        .filter(t => t !== `${tagId}*${tagName}`)
                                                        .join(',')

                wholeQueueLead.tag_ids = updatedLeadTags.length > 0 ? updatedLeadTags : null
            }

            if(originalQueueLead){
                const updatedLeadTags = originalQueueLead.tag_ids
                                                        .split(',')
                                                        .filter(t => t !== `${tagId}*${tagName}`)
                                                        .join(',')

                originalQueueLead.tag_ids = updatedLeadTags.length > 0 ? updatedLeadTags : null
            }

            if(calledQueueLead){
                const updatedLeadTags = calledQueueLead.tag_ids
                                                        .split(',')
                                                        .filter(t => t !== `${tagId}*${tagName}`)
                                                        .join(',')

                calledQueueLead.tag_ids = updatedLeadTags.length > 0 ? updatedLeadTags : null
            }

            if(state.currentLead?.lead_id === id){
                const updatedLeadTags = state.currentLead.tag_ids
                                                        .split(',')
                                                        .filter(t => t !== `${tagId}*${tagName}`)
                                                        .join(',')

                state.currentLead.tag_ids = updatedLeadTags.length > 0 ? updatedLeadTags : null
            }
        },
        updateLeadNameInfo(state, action) {
            state.leadInfoStatus.status_name = action.payload;
        },
        updateSpecificLeadEntry(state, action){ // updates the entire record for a single lead in the queue
            const { id, updatedLead } = action.payload;

            // Find the lead by id
            const lead = state.queue.findIndex((lead) => lead.lead_id === id);

            const wholeQueueLead = state.wholeQueue.findIndex((lead) => lead.lead_id === id);
            const originalQueueLead = state.originalQueue.findIndex((lead) => lead.lead_id === id);
            const calledQueueLead = state.calledQueue.findIndex((lead) => lead.lead_id === id);

            if(lead > -1){
                state.queue[lead] = {
                    ...state.queue[lead],
                    ...updatedLead,
                }
            }

            if(wholeQueueLead > -1){
                state.wholeQueue[wholeQueueLead] = {
                    ...state.wholeQueue[wholeQueueLead],
                    ...updatedLead,
                }
            }

            if(originalQueueLead > -1){
                state.originalQueue[originalQueueLead] = {
                    ...state.originalQueue[originalQueueLead],
                    ...updatedLead,
                }
            }

            if(calledQueueLead > -1){
                state.calledQueue[calledQueueLead] = {
                    ...state.calledQueue[calledQueueLead],
                    ...updatedLead,
                }
            }

            if (state.currentLead?.lead_id === id) {
                state.currentLead = {...state.currentLead, ...updatedLead}
            }
        },
        resetCalledQueue(state){
            state.calledQueue = [];
        },
        setQueueSource(state, action){
            state.queueSource = action.payload
        }
    },
});
export const {
    resetCalledQueue,
    setQueue,
    addQueue,
    setBackup,
    updateLeadNameInfo,
    setWholeQueue,
    addToBackup,
    addCurrentLead,
    incrementQueue,
    setQueueSort,
    updateSpecificLead,
    removeTagFromLead,
    updateSpecificLeadEntry,
    setQueueSource,
} = queueSlice.actions;

export default queueSlice.reducer;
